import styled from '@emotion/styled';
import Button from '~/scripts/components/Button';

export const Wrapper = styled.aside`
  background: rgba(white, 0.9);
  z-index: 600;
  position: absolute;
  display: none;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  backdrop-filter: blur(3px);
  border-left: 4px solid white;
  border-radius: 4px;
  width: 230px;
  z-index: 1100;
  ${(p) => p.theme.breakpoints.sm.up} {
    pointer-events: none;
    ${(p) => p.isInverted && 'transform: translate3d(calc(-100% - 45px), 0, 0);'}
  }

  ${(p) =>
    p.isVisible &&
    `
    display: inline-block;
  `}
`;

export const Inner = styled.div`
  position: relative;
`;

export const Header = styled.header`
  padding: 12px 12px 8px;
`;

export const Title = styled.h5`
  font-weight: 700;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: 2px;
  font-size: 13px;
`;

export const Close = styled(Button)`
  position: absolute;
  right: 12px;
  pointer-events: all;
`;

export const SubTitle = styled.h6`
  color: ${(p) => p.theme.colors.lightText};
  font-weight: 400;
  line-height: 1.2;
  margin-top: 0;
  margin-bottom: var(--margin-vertical-xs, 4px);
  font-size: 12px;
`;

export const Body = styled.main`
  background: rgba(0, 0, 0, 0.03);
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  padding: var(--margin-vertical-xs, 4px) 12px;
`;

export const Text = styled.p`
  padding: 0;
  font-size: 12px;
  margin: var(--margin-vertical-xs, 4px) 0 0 0;
`;

export const ItemWrapper = styled.div`
  width: 100%;
  display: flex;
  margin: var(--margin-vertical-xs, 4px) 0;
  justify-content: flex-start;
  ${(p) =>
    p.isWrapping &&
    `
    flex-wrap: wrap;
    justify-content: space-between;
  `}
  ${(p) =>
    p.columns === 2 &&
    `
    > div {
      flex: 0 1 calc(50% - 6px);
    }
  `}
  ${(p) =>
    p.columns === 3 &&
    `
    > div {
      flex: 0 1 calc(33% - 6px);
    }
  `}
`;

export const Item = styled.div`
  ${(p) => p.theme.font.family.condensed}
  font-weight: 700;
  text-align: center;
  padding: 5px;
  border-radius: 3px;
  font-size: 13px;
  margin-right: 6px;

  ${(p) =>
    p.isBordered
      ? `
      border: 1px solid ${p.theme.colors.vizred};
      color: ${p.theme.colors.vizred};
      ${
        p.type === 'recovered'
          ? `
        border: 1px solid ${p.theme.colors.vizgreenDark};
        color: ${p.theme.colors.vizgreenDark};
        `
          : ''
      }
      ${
        p.type === 'death'
          ? `
        border: 1px solid ${p.theme.colors.vizblack};
        color: ${p.theme.colors.vizblack};
        `
          : ''
      }
      `
      : `
      background-color: ${p.theme.colors.vizredReduced};
      color: ${p.theme.colors.vizred};
      ${
        p.type === 'recovered'
          ? `
        background-color: ${p.theme.colors.vizgreenReduced};
        color: ${p.theme.colors.vizgreenDark};
        `
          : ''
      }
      ${
        p.type === 'death'
          ? `
        background-color: ${p.theme.colors.vizblackReduced};
        color: ${p.theme.colors.vizblack};
        `
          : ''
      }
    `}
`;

export const Value = styled.div`
  font-weight: 700;
  text-align: center;
  padding: 0;
  line-height: 1.1;
  font-size: 21px;
`;

export const Label = styled.div`
  color: ${(p) => p.theme.colors.lightText};
  text-align: center;
  line-height: 1.2;
  font-size: 12px;
`;

export const Timestamp = styled.time`
  display: inline-block;
  color: ${(p) => p.theme.colors.lightText};
  padding: 8px 12px;
  font-size: 12px;
`;
